// redux/slices/userSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { UserInput } from '../../interfaces/user';

interface UserState {
  users: UserInput[];
  loading: boolean;
  error: string | null;
}

const initialState: UserState = {
  users: [],
  loading: false,
  error: null
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUsers(state, action: PayloadAction<UserInput[]>) {
      state.users = action.payload;
    },
    addUser(state, action: PayloadAction<UserInput>) {
      state.users.push(action.payload);
    },
    updateUser(state, action: PayloadAction<UserInput>) {
      const index = state.users.findIndex(u => u.id === action.payload.id);
      if (index !== -1) state.users[index] = action.payload;
    },
    setLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
    setError(state, action: PayloadAction<string | null>) {
      state.error = action.payload;
    }
  }
});

export const { setUsers, addUser, updateUser, setLoading, setError } = userSlice.actions;
export default userSlice.reducer;
